$(function() {
  $('.tabs-nav a').click(function() {

    // Check for active
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');

    // Display active tab
    let currentTab = $(this).attr('href');
    $('.tabs-content div').hide();
    $(currentTab).show();

    return false;
  });

  jQuery(document).on("click", ".home_featured_product", function() {
    jQuery(".home_featured_product").removeClass("active");
    jQuery(this).addClass("active");
    jQuery(".grid.grid--uniform").hide();
    var datatab = jQuery(this).attr("data-tab");
    jQuery(this).closest(".home_featured_product__outer").next(".page-width").find(".grid.grid--uniform").each(function(){
       var innrdatatab = jQuery(this).attr("data-tab");
        if(jQuery.trim(datatab) == jQuery.trim(innrdatatab)){
            jQuery(this).show();
        }
    });
  });

  
    var tl = new TimelineMax(),
      $videoContainer = $('.cb-video-container'),
      $video = $videoContainer.find('.video'),
      $playPauseClickArea = $videoContainer.find('.play-pause--click-area'),
      $playPauseContainer = $videoContainer.find('.play-pause--container'),
      $playIcon = $videoContainer.find('.play-icon'),
      $pauseIcon = $videoContainer.find('.pause-icon'),
    
      iconIsToggled = false,
      iconEase = Back.easeInOut.config(1.7),
      iconDuration = 0.3;
    
    setupVideo();
    
    // functions 
    function setupVideo() {
    TweenMax.set($pauseIcon, {autoAlpha:0, scale:0});
    TweenMax.set($playPauseClickArea, {backgroundColor:'rgba(0, 0, 0, 0.5)'})
    };
    
    function showPaused() {
    iconIsToggled = true;
    
    tl.play();
    tl.to($playIcon, iconDuration, {autoAlpha:0, scale:0, ease:iconEase}, 0);
    tl.to($pauseIcon, iconDuration, {autoAlpha:1, scale:1, ease:iconEase}, 0);
    
    TweenMax.to($playPauseClickArea, iconDuration, {backgroundColor:'rgba(0, 0, 0, 0)'}, 0)
    
    console.log('playing - show pause');
    $video.get(0).play();
    $video.addClass('firstPlay');
    }
    
    function showPlay() {
    iconIsToggled = false;
    
    tl.reverse();
    
    TweenMax.to($playPauseClickArea, iconDuration, {backgroundColor:'rgba(0, 0, 0, 0.5)'}, 0)
    
    console.log('paused - show play'); 
    $video.get(0).pause();
    }
    
    // event handlers
    $playPauseClickArea.on('click', function(){
    !iconIsToggled ? showPaused() : showPlay();
    });
    
    $playPauseClickArea.on('mouseleave', function() {
    if (iconIsToggled === true) TweenMax.to($playPauseContainer, iconDuration, {autoAlpha:0}, 0);
    console.log('mouseleave');
    });
    
    $playPauseClickArea.on('mouseenter', function() {
    TweenMax.to($playPauseContainer, iconDuration, {autoAlpha:1}, 0);
    console.log('mouseenter');
    });
    
    $video.on('ended',function(){ 
    // TODO: showReplay()
    console.log('video ended')
    });






  $('.text-image-functionality-slider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrow: false,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      arrow: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      arrow: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      arrow: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});